import { VendorTiersGrowths } from '../../../components/Vendor/TiersGrowths';

export function VendorTiersAndGrowths() {
  return <VendorTiersGrowths />;
}
